module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAQRJREFUWEftlzEOgjAUhr9iok4YzqF3EG7g4CzxJt7E4OwdxBs46DlAJjUBTAcSQqhCg2JMu7Z/39e/b/ifoOcleq6PEiDashkMmOc5rg6kEIRpytFZs3mlVwIkAeccpjrFC42Ai+0z0wK4BuRSmGV4zpqwDUi0xbUsDlIz8dUuy32lAwXAuwtUYE31rQGSHYdqX8j/tld4ZZj/BWjaCx9zwAAYB4wDxgHjgHHg6w7YN4ZNi5bPJWMenSQi4K4DAIw6Afi5SFa4kQScEETVKFbsfzyQxAGhgHjis6j7os4Aeovldem3bTPWpeXqHa9HM4ul7nQkp6I0Y689mrV9re753qfjJzNDxCFxFrObAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone.png
// module id = UqHI
// module chunks = 1